/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AttachEvidenceToInstanceDto,
  CompleteTaskInstanceDto,
  ComplianceScoreResponseDto,
  ComplianceTaskDefinitionResponseDto,
  ComplianceTaskInstanceListResponseDto,
  ComplianceTaskInstanceResponseDto,
  CreateTaskDefinitionCommandControllerCreate201,
  CreateTaskDefinitionDto,
  GetComplianceScoreQueryControllerGetScoreParams,
  ListTaskDefinitionsByNurseryQueryControllerListParams,
  ListTaskInstancesByNurseryQueryControllerListParams,
  MarkOverdueInstancesCommandControllerMarkOverdue200,
  RescheduleTaskInstanceDto,
  UpdateTaskDefinitionDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a new compliance task definition
 */
export const createTaskDefinitionCommandControllerCreate = (
  nurseryId: string,
  createTaskDefinitionDto: CreateTaskDefinitionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateTaskDefinitionCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/compliance-tasks/definitions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTaskDefinitionDto,
    signal,
  });
};

export const getCreateTaskDefinitionCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaskDefinitionCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateTaskDefinitionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaskDefinitionCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateTaskDefinitionDto },
  TContext
> => {
  const mutationKey = ["createTaskDefinitionCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskDefinitionCommandControllerCreate>>,
    { nurseryId: string; data: CreateTaskDefinitionDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createTaskDefinitionCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskDefinitionCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTaskDefinitionCommandControllerCreate>>
  >;
export type CreateTaskDefinitionCommandControllerCreateMutationBody =
  CreateTaskDefinitionDto;
export type CreateTaskDefinitionCommandControllerCreateMutationError = void;

/**
 * @summary Create a new compliance task definition
 */
export const useCreateTaskDefinitionCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTaskDefinitionCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateTaskDefinitionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTaskDefinitionCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateTaskDefinitionDto },
  TContext
> => {
  return useMutation(
    getCreateTaskDefinitionCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List compliance task definitions for a nursery (paginated)
 */
export const listTaskDefinitionsByNurseryQueryControllerList = (
  nurseryId: string,
  params?: ListTaskDefinitionsByNurseryQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/nurseries/${nurseryId}/compliance-tasks/definitions`,
    method: "GET",
    params,
    signal,
  });
};

export const getListTaskDefinitionsByNurseryQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListTaskDefinitionsByNurseryQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/compliance-tasks/definitions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListTaskDefinitionsByNurseryQueryControllerListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskDefinitionsByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTaskDefinitionsByNurseryQueryControllerListQueryKey(
      nurseryId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>>
  > = ({ signal }) =>
    listTaskDefinitionsByNurseryQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTaskDefinitionsByNurseryQueryControllerListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>>
  >;
export type ListTaskDefinitionsByNurseryQueryControllerListQueryError = unknown;

export function useListTaskDefinitionsByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | ListTaskDefinitionsByNurseryQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTaskDefinitionsByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskDefinitionsByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTaskDefinitionsByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskDefinitionsByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List compliance task definitions for a nursery (paginated)
 */

export function useListTaskDefinitionsByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskDefinitionsByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskDefinitionsByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTaskDefinitionsByNurseryQueryControllerListQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a compliance task definition
 */
export const updateTaskDefinitionCommandControllerUpdate = (
  definitionId: string,
  updateTaskDefinitionDto: UpdateTaskDefinitionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/definitions/${definitionId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateTaskDefinitionDto,
    signal,
  });
};

export const getUpdateTaskDefinitionCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskDefinitionCommandControllerUpdate>>,
    TError,
    { definitionId: string; data: UpdateTaskDefinitionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaskDefinitionCommandControllerUpdate>>,
  TError,
  { definitionId: string; data: UpdateTaskDefinitionDto },
  TContext
> => {
  const mutationKey = ["updateTaskDefinitionCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskDefinitionCommandControllerUpdate>>,
    { definitionId: string; data: UpdateTaskDefinitionDto }
  > = (props) => {
    const { definitionId, data } = props ?? {};

    return updateTaskDefinitionCommandControllerUpdate(definitionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskDefinitionCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTaskDefinitionCommandControllerUpdate>>
  >;
export type UpdateTaskDefinitionCommandControllerUpdateMutationBody =
  UpdateTaskDefinitionDto;
export type UpdateTaskDefinitionCommandControllerUpdateMutationError = void;

/**
 * @summary Update a compliance task definition
 */
export const useUpdateTaskDefinitionCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTaskDefinitionCommandControllerUpdate>>,
      TError,
      { definitionId: string; data: UpdateTaskDefinitionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTaskDefinitionCommandControllerUpdate>>,
  TError,
  { definitionId: string; data: UpdateTaskDefinitionDto },
  TContext
> => {
  return useMutation(
    getUpdateTaskDefinitionCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Delete a compliance task definition created in error (organisation admins only)
 */
export const deleteTaskDefinitionCommandControllerDelete = (
  definitionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/definitions/${definitionId}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteTaskDefinitionCommandControllerDeleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskDefinitionCommandControllerDelete>>,
    TError,
    { definitionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaskDefinitionCommandControllerDelete>>,
  TError,
  { definitionId: string },
  TContext
> => {
  const mutationKey = ["deleteTaskDefinitionCommandControllerDelete"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskDefinitionCommandControllerDelete>>,
    { definitionId: string }
  > = (props) => {
    const { definitionId } = props ?? {};

    return deleteTaskDefinitionCommandControllerDelete(definitionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskDefinitionCommandControllerDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteTaskDefinitionCommandControllerDelete>>
  >;

export type DeleteTaskDefinitionCommandControllerDeleteMutationError = void;

/**
 * @summary Delete a compliance task definition created in error (organisation admins only)
 */
export const useDeleteTaskDefinitionCommandControllerDelete = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTaskDefinitionCommandControllerDelete>>,
      TError,
      { definitionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaskDefinitionCommandControllerDelete>>,
  TError,
  { definitionId: string },
  TContext
> => {
  return useMutation(
    getDeleteTaskDefinitionCommandControllerDeleteMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get a compliance task definition by ID
 */
export const getTaskDefinitionByIdQueryControllerGet = (
  definitionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ComplianceTaskDefinitionResponseDto>({
    url: `/v1/compliance-tasks/definitions/${definitionId}`,
    method: "GET",
    signal,
  });
};

export const getGetTaskDefinitionByIdQueryControllerGetQueryKey = (
  definitionId: string,
) => {
  return [`/v1/compliance-tasks/definitions/${definitionId}`] as const;
};

export const getGetTaskDefinitionByIdQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
  TError = void,
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTaskDefinitionByIdQueryControllerGetQueryKey(definitionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>
  > = ({ signal }) =>
    getTaskDefinitionByIdQueryControllerGet(definitionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: definitionId !== null && definitionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskDefinitionByIdQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>
>;
export type GetTaskDefinitionByIdQueryControllerGetQueryError = void;

export function useGetTaskDefinitionByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
  TError = void,
>(
  definitionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskDefinitionByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
  TError = void,
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskDefinitionByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
  TError = void,
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a compliance task definition by ID
 */

export function useGetTaskDefinitionByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
  TError = void,
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskDefinitionByIdQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskDefinitionByIdQueryControllerGetQueryOptions(
    definitionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Deactivate a compliance task definition
 */
export const deactivateTaskDefinitionCommandControllerDeactivate = (
  definitionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/definitions/${definitionId}/deactivate`,
    method: "POST",
    signal,
  });
};

export const getDeactivateTaskDefinitionCommandControllerDeactivateMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deactivateTaskDefinitionCommandControllerDeactivate>
      >,
      TError,
      { definitionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deactivateTaskDefinitionCommandControllerDeactivate>
    >,
    TError,
    { definitionId: string },
    TContext
  > => {
    const mutationKey = ["deactivateTaskDefinitionCommandControllerDeactivate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deactivateTaskDefinitionCommandControllerDeactivate>
      >,
      { definitionId: string }
    > = (props) => {
      const { definitionId } = props ?? {};

      return deactivateTaskDefinitionCommandControllerDeactivate(definitionId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeactivateTaskDefinitionCommandControllerDeactivateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deactivateTaskDefinitionCommandControllerDeactivate>
    >
  >;

export type DeactivateTaskDefinitionCommandControllerDeactivateMutationError =
  void;

/**
 * @summary Deactivate a compliance task definition
 */
export const useDeactivateTaskDefinitionCommandControllerDeactivate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deactivateTaskDefinitionCommandControllerDeactivate>
      >,
      TError,
      { definitionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof deactivateTaskDefinitionCommandControllerDeactivate>
  >,
  TError,
  { definitionId: string },
  TContext
> => {
  return useMutation(
    getDeactivateTaskDefinitionCommandControllerDeactivateMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * @summary Complete a compliance task instance
 */
export const completeTaskInstanceCommandControllerComplete = (
  instanceId: string,
  completeTaskInstanceDto: CompleteTaskInstanceDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/instances/${instanceId}/complete`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: completeTaskInstanceDto,
    signal,
  });
};

export const getCompleteTaskInstanceCommandControllerCompleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeTaskInstanceCommandControllerComplete>>,
    TError,
    { instanceId: string; data: CompleteTaskInstanceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeTaskInstanceCommandControllerComplete>>,
  TError,
  { instanceId: string; data: CompleteTaskInstanceDto },
  TContext
> => {
  const mutationKey = ["completeTaskInstanceCommandControllerComplete"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeTaskInstanceCommandControllerComplete>>,
    { instanceId: string; data: CompleteTaskInstanceDto }
  > = (props) => {
    const { instanceId, data } = props ?? {};

    return completeTaskInstanceCommandControllerComplete(instanceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteTaskInstanceCommandControllerCompleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof completeTaskInstanceCommandControllerComplete>>
  >;
export type CompleteTaskInstanceCommandControllerCompleteMutationBody =
  CompleteTaskInstanceDto;
export type CompleteTaskInstanceCommandControllerCompleteMutationError = void;

/**
 * @summary Complete a compliance task instance
 */
export const useCompleteTaskInstanceCommandControllerComplete = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeTaskInstanceCommandControllerComplete>>,
      TError,
      { instanceId: string; data: CompleteTaskInstanceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeTaskInstanceCommandControllerComplete>>,
  TError,
  { instanceId: string; data: CompleteTaskInstanceDto },
  TContext
> => {
  return useMutation(
    getCompleteTaskInstanceCommandControllerCompleteMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Reschedule an open compliance task instance's due date (organisation admins only)
 */
export const rescheduleTaskInstanceCommandControllerReschedule = (
  instanceId: string,
  rescheduleTaskInstanceDto: RescheduleTaskInstanceDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/instances/${instanceId}/reschedule`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: rescheduleTaskInstanceDto,
    signal,
  });
};

export const getRescheduleTaskInstanceCommandControllerRescheduleMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof rescheduleTaskInstanceCommandControllerReschedule>
      >,
      TError,
      { instanceId: string; data: RescheduleTaskInstanceDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof rescheduleTaskInstanceCommandControllerReschedule>
    >,
    TError,
    { instanceId: string; data: RescheduleTaskInstanceDto },
    TContext
  > => {
    const mutationKey = ["rescheduleTaskInstanceCommandControllerReschedule"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof rescheduleTaskInstanceCommandControllerReschedule>
      >,
      { instanceId: string; data: RescheduleTaskInstanceDto }
    > = (props) => {
      const { instanceId, data } = props ?? {};

      return rescheduleTaskInstanceCommandControllerReschedule(
        instanceId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RescheduleTaskInstanceCommandControllerRescheduleMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof rescheduleTaskInstanceCommandControllerReschedule>
    >
  >;
export type RescheduleTaskInstanceCommandControllerRescheduleMutationBody =
  RescheduleTaskInstanceDto;
export type RescheduleTaskInstanceCommandControllerRescheduleMutationError =
  void;

/**
 * @summary Reschedule an open compliance task instance's due date (organisation admins only)
 */
export const useRescheduleTaskInstanceCommandControllerReschedule = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof rescheduleTaskInstanceCommandControllerReschedule>
      >,
      TError,
      { instanceId: string; data: RescheduleTaskInstanceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rescheduleTaskInstanceCommandControllerReschedule>>,
  TError,
  { instanceId: string; data: RescheduleTaskInstanceDto },
  TContext
> => {
  return useMutation(
    getRescheduleTaskInstanceCommandControllerRescheduleMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * @summary Reopen a completed compliance task instance so it can be re-completed (organisation admins only)
 */
export const reopenTaskInstanceCommandControllerReopen = (
  instanceId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/instances/${instanceId}/reopen`,
    method: "POST",
    signal,
  });
};

export const getReopenTaskInstanceCommandControllerReopenMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenTaskInstanceCommandControllerReopen>>,
    TError,
    { instanceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenTaskInstanceCommandControllerReopen>>,
  TError,
  { instanceId: string },
  TContext
> => {
  const mutationKey = ["reopenTaskInstanceCommandControllerReopen"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reopenTaskInstanceCommandControllerReopen>>,
    { instanceId: string }
  > = (props) => {
    const { instanceId } = props ?? {};

    return reopenTaskInstanceCommandControllerReopen(instanceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenTaskInstanceCommandControllerReopenMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reopenTaskInstanceCommandControllerReopen>>
  >;

export type ReopenTaskInstanceCommandControllerReopenMutationError = void;

/**
 * @summary Reopen a completed compliance task instance so it can be re-completed (organisation admins only)
 */
export const useReopenTaskInstanceCommandControllerReopen = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reopenTaskInstanceCommandControllerReopen>>,
      TError,
      { instanceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reopenTaskInstanceCommandControllerReopen>>,
  TError,
  { instanceId: string },
  TContext
> => {
  return useMutation(
    getReopenTaskInstanceCommandControllerReopenMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Delete an erroneous compliance task instance (organisation admins only)
 */
export const deleteTaskInstanceCommandControllerDelete = (
  instanceId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/instances/${instanceId}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteTaskInstanceCommandControllerDeleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaskInstanceCommandControllerDelete>>,
    TError,
    { instanceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaskInstanceCommandControllerDelete>>,
  TError,
  { instanceId: string },
  TContext
> => {
  const mutationKey = ["deleteTaskInstanceCommandControllerDelete"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskInstanceCommandControllerDelete>>,
    { instanceId: string }
  > = (props) => {
    const { instanceId } = props ?? {};

    return deleteTaskInstanceCommandControllerDelete(instanceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskInstanceCommandControllerDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteTaskInstanceCommandControllerDelete>>
  >;

export type DeleteTaskInstanceCommandControllerDeleteMutationError = void;

/**
 * @summary Delete an erroneous compliance task instance (organisation admins only)
 */
export const useDeleteTaskInstanceCommandControllerDelete = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTaskInstanceCommandControllerDelete>>,
      TError,
      { instanceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaskInstanceCommandControllerDelete>>,
  TError,
  { instanceId: string },
  TContext
> => {
  return useMutation(
    getDeleteTaskInstanceCommandControllerDeleteMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get a compliance task instance by ID
 */
export const getTaskInstanceByIdQueryControllerGet = (
  instanceId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ComplianceTaskInstanceResponseDto>({
    url: `/v1/compliance-tasks/instances/${instanceId}`,
    method: "GET",
    signal,
  });
};

export const getGetTaskInstanceByIdQueryControllerGetQueryKey = (
  instanceId: string,
) => {
  return [`/v1/compliance-tasks/instances/${instanceId}`] as const;
};

export const getGetTaskInstanceByIdQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
  TError = void,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTaskInstanceByIdQueryControllerGetQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>
  > = ({ signal }) => getTaskInstanceByIdQueryControllerGet(instanceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: instanceId !== null && instanceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskInstanceByIdQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>
>;
export type GetTaskInstanceByIdQueryControllerGetQueryError = void;

export function useGetTaskInstanceByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
  TError = void,
>(
  instanceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskInstanceByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
  TError = void,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTaskInstanceByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
  TError = void,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a compliance task instance by ID
 */

export function useGetTaskInstanceByIdQueryControllerGet<
  TData = Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
  TError = void,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTaskInstanceByIdQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTaskInstanceByIdQueryControllerGetQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Remove an evidence file from a compliance task instance (organisation admins only)
 */
export const removeInstanceEvidenceCommandControllerRemove = (
  instanceId: string,
  fileId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/instances/${instanceId}/evidence/${fileId}`,
    method: "DELETE",
    signal,
  });
};

export const getRemoveInstanceEvidenceCommandControllerRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeInstanceEvidenceCommandControllerRemove>>,
    TError,
    { instanceId: string; fileId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeInstanceEvidenceCommandControllerRemove>>,
  TError,
  { instanceId: string; fileId: string },
  TContext
> => {
  const mutationKey = ["removeInstanceEvidenceCommandControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeInstanceEvidenceCommandControllerRemove>>,
    { instanceId: string; fileId: string }
  > = (props) => {
    const { instanceId, fileId } = props ?? {};

    return removeInstanceEvidenceCommandControllerRemove(instanceId, fileId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveInstanceEvidenceCommandControllerRemoveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeInstanceEvidenceCommandControllerRemove>>
  >;

export type RemoveInstanceEvidenceCommandControllerRemoveMutationError = void;

/**
 * @summary Remove an evidence file from a compliance task instance (organisation admins only)
 */
export const useRemoveInstanceEvidenceCommandControllerRemove = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeInstanceEvidenceCommandControllerRemove>>,
      TError,
      { instanceId: string; fileId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeInstanceEvidenceCommandControllerRemove>>,
  TError,
  { instanceId: string; fileId: string },
  TContext
> => {
  return useMutation(
    getRemoveInstanceEvidenceCommandControllerRemoveMutationOptions(options),
    queryClient,
  );
};
/**
 * Promotes an AWAITING_EVIDENCE instance to COMPLETED. The file must be uploaded separately via the file module before calling this endpoint. Idempotent: returns 204 if the instance is already COMPLETED.
 * @summary Attach a previously-uploaded certificate to an awaiting-evidence task
 */
export const attachEvidenceToInstanceCommandControllerAttach = (
  instanceId: string,
  attachEvidenceToInstanceDto: AttachEvidenceToInstanceDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/compliance-tasks/instances/${instanceId}/attach-evidence`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: attachEvidenceToInstanceDto,
    signal,
  });
};

export const getAttachEvidenceToInstanceCommandControllerAttachMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof attachEvidenceToInstanceCommandControllerAttach>
      >,
      TError,
      { instanceId: string; data: AttachEvidenceToInstanceDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof attachEvidenceToInstanceCommandControllerAttach>>,
    TError,
    { instanceId: string; data: AttachEvidenceToInstanceDto },
    TContext
  > => {
    const mutationKey = ["attachEvidenceToInstanceCommandControllerAttach"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof attachEvidenceToInstanceCommandControllerAttach>
      >,
      { instanceId: string; data: AttachEvidenceToInstanceDto }
    > = (props) => {
      const { instanceId, data } = props ?? {};

      return attachEvidenceToInstanceCommandControllerAttach(instanceId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AttachEvidenceToInstanceCommandControllerAttachMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof attachEvidenceToInstanceCommandControllerAttach>>
  >;
export type AttachEvidenceToInstanceCommandControllerAttachMutationBody =
  AttachEvidenceToInstanceDto;
export type AttachEvidenceToInstanceCommandControllerAttachMutationError = void;

/**
 * @summary Attach a previously-uploaded certificate to an awaiting-evidence task
 */
export const useAttachEvidenceToInstanceCommandControllerAttach = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof attachEvidenceToInstanceCommandControllerAttach>
      >,
      TError,
      { instanceId: string; data: AttachEvidenceToInstanceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachEvidenceToInstanceCommandControllerAttach>>,
  TError,
  { instanceId: string; data: AttachEvidenceToInstanceDto },
  TContext
> => {
  return useMutation(
    getAttachEvidenceToInstanceCommandControllerAttachMutationOptions(options),
    queryClient,
  );
};
/**
 * System endpoint called by GCP Cloud Scheduler to check for compliance task instances that have passed their due date and mark them as overdue.
 * @summary Mark overdue compliance task instances (System Task)
 */
export const markOverdueInstancesCommandControllerMarkOverdue = (
  signal?: AbortSignal,
) => {
  return axiosClient<MarkOverdueInstancesCommandControllerMarkOverdue200>({
    url: `/v1/compliance-tasks/instances/mark-overdue`,
    method: "POST",
    signal,
  });
};

export const getMarkOverdueInstancesCommandControllerMarkOverdueMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markOverdueInstancesCommandControllerMarkOverdue>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof markOverdueInstancesCommandControllerMarkOverdue>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["markOverdueInstancesCommandControllerMarkOverdue"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof markOverdueInstancesCommandControllerMarkOverdue>
      >,
      void
    > = () => {
      return markOverdueInstancesCommandControllerMarkOverdue();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkOverdueInstancesCommandControllerMarkOverdueMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof markOverdueInstancesCommandControllerMarkOverdue>>
  >;

export type MarkOverdueInstancesCommandControllerMarkOverdueMutationError =
  void;

/**
 * @summary Mark overdue compliance task instances (System Task)
 */
export const useMarkOverdueInstancesCommandControllerMarkOverdue = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markOverdueInstancesCommandControllerMarkOverdue>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markOverdueInstancesCommandControllerMarkOverdue>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMarkOverdueInstancesCommandControllerMarkOverdueMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List compliance task instances for a nursery (paginated)
 */
export const listTaskInstancesByNurseryQueryControllerList = (
  nurseryId: string,
  params?: ListTaskInstancesByNurseryQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ComplianceTaskInstanceListResponseDto>({
    url: `/v1/nurseries/${nurseryId}/compliance-tasks/instances`,
    method: "GET",
    params,
    signal,
  });
};

export const getListTaskInstancesByNurseryQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListTaskInstancesByNurseryQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/compliance-tasks/instances`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListTaskInstancesByNurseryQueryControllerListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskInstancesByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTaskInstancesByNurseryQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>>
  > = ({ signal }) =>
    listTaskInstancesByNurseryQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTaskInstancesByNurseryQueryControllerListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>>
  >;
export type ListTaskInstancesByNurseryQueryControllerListQueryError = unknown;

export function useListTaskInstancesByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | ListTaskInstancesByNurseryQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTaskInstancesByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskInstancesByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTaskInstancesByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskInstancesByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List compliance task instances for a nursery (paginated)
 */

export function useListTaskInstancesByNurseryQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListTaskInstancesByNurseryQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTaskInstancesByNurseryQueryControllerList>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTaskInstancesByNurseryQueryControllerListQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get compliance score for a nursery
 */
export const getComplianceScoreQueryControllerGetScore = (
  nurseryId: string,
  params?: GetComplianceScoreQueryControllerGetScoreParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ComplianceScoreResponseDto>({
    url: `/v1/nurseries/${nurseryId}/compliance-tasks/score`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetComplianceScoreQueryControllerGetScoreQueryKey = (
  nurseryId: string,
  params?: GetComplianceScoreQueryControllerGetScoreParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/compliance-tasks/score`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetComplianceScoreQueryControllerGetScoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetComplianceScoreQueryControllerGetScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetComplianceScoreQueryControllerGetScoreQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>
  > = ({ signal }) =>
    getComplianceScoreQueryControllerGetScore(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetComplianceScoreQueryControllerGetScoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>
>;
export type GetComplianceScoreQueryControllerGetScoreQueryError = unknown;

export function useGetComplianceScoreQueryControllerGetScore<
  TData = Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | GetComplianceScoreQueryControllerGetScoreParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
          TError,
          Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetComplianceScoreQueryControllerGetScore<
  TData = Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetComplianceScoreQueryControllerGetScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
          TError,
          Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetComplianceScoreQueryControllerGetScore<
  TData = Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetComplianceScoreQueryControllerGetScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get compliance score for a nursery
 */

export function useGetComplianceScoreQueryControllerGetScore<
  TData = Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: GetComplianceScoreQueryControllerGetScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getComplianceScoreQueryControllerGetScore>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetComplianceScoreQueryControllerGetScoreQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
